import { useEffect, useRef, useState } from 'react';

import { ColumnPickerList } from 'app/modules/localTableSettings/components/ColumnPickerList';
import { useLocalTableConfig } from 'app/modules/localTableSettings/hooks';
import { LocalColumnConfig } from 'app/modules/localTableSettings/models';
import { LocalTableConfigSidebarDefinition } from 'app/modules/sidebar/models';
import { hideSidebar } from 'app/modules/sidebar/slice';
import { U21SideMenu } from 'app/shared/u21-ui/components/dashboard';
import { useAppDispatch } from 'app/store/storeHooks';

interface Props {
  data: LocalTableConfigSidebarDefinition['data'];
}

export const SidebarLocalTableConfig = ({ data }: Props) => {
  const dispatch = useAppDispatch();
  const [columns, setColumns] = useLocalTableConfig(data);
  const [draftColumns, setDraftColumns] =
    useState<LocalColumnConfig[]>(columns);

  const columnsRef = useRef(columns);
  useEffect(() => {
    columnsRef.current = columns;
  }, [columns]);
  // Sync local draft when the table type changes or the store gets repopulated.
  useEffect(() => {
    setDraftColumns(columnsRef.current);
  }, [data]);

  const handleSave = () => {
    setColumns(draftColumns);
    dispatch(hideSidebar());
  };

  return (
    <U21SideMenu
      title="Choose Columns"
      actionButtonProps={{ children: 'Save' }}
      onAction={handleSave}
    >
      <ColumnPickerList columns={draftColumns} onChange={setDraftColumns} />
    </U21SideMenu>
  );
};
